<template>
  <section class="module register-box over">
    <div class="contents centered">
      <h2 class="uppercase huge">Sei un musicista o un appassionato di musica?</h2>
      <router-link to="/signup" class="button button-big button-azure">Registrati per scaricare gratuitamente i nostri brani</router-link>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style scoped>

@media (max-width: 586px) {
  .button-big {
    height: 61px;
  }
}
</style>




// WEBPACK FOOTER //
// src/vue/components/AlbumBanner.vue